<div class="root sm-font-container">

  <form [formGroup]="form" fxLayout="row wrap" fxLayoutGap="15px 0 grid">

    <!-- Show in Tasks -->
    <div fxFlex="100" fxLayout="row" fxLayoutAlign="end center" class="mb-10">
      <mat-checkbox formControlName="showTasks">
        Show in Tasks
      </mat-checkbox>
    </div>

    <!-- Template Type -->
    <mat-form-field fxFlex="1 1 40" appearance="outline">
      <mat-label>Template Type</mat-label>
      <mat-select formControlName="useType">
        <mat-option *ngFor="let item of useTypeOptions" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Task Template Name -->
    <mat-form-field appearance="outline" fxFlex="1 1 60">
      <mat-label>Task Template Name</mat-label>
      <input matInput placeholder="Task Template Name" formControlName="name">
    </mat-form-field>

    <!-- Status -->
    <mat-form-field fxFlex="1 1 40" appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let item of statusOptions" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Task Type -->
    <mat-form-field fxFlex="1 1 60" appearance="outline">
      <mat-label>Task Type</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let item of typeOptions" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Priority -->
    <mat-form-field fxFlex="1 1 40" appearance="outline">
      <mat-label>Priority</mat-label>
      <mat-select formControlName="priority">
        <mat-option *ngFor="let item of priorityOptions" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Assigned To -->
    <div>
      <ng-container *ngIf="isEdit">
        <mat-form-field appearance="outline" [style.width.%]="130">
          <mat-label>Assigned To</mat-label>

          <input
            type="text"
            matInput
            formControlName="assigneeId"
            placeholder="Assigned To"
            (input)="onchangemat()"
            [matAutocomplete]="auto">

          <mat-icon matSuffix>
            <i class="icon-search"></i>
          </mat-icon>

          <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText">
            <mat-option
              *ngFor="let user of conversationUsers$ | async"
              [value]="user"
              [disabled]="user.status === 'Inactive'"
              [ngStyle]="{'color': user.status === 'Inactive' ? 'gray' : 'initial'}">

              {{ user?.label }}

            </mat-option>
          </mat-autocomplete>

        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="!isEdit">
        <mat-form-field appearance="outline" [style.width.%]="130">
          <mat-label>Assigned To</mat-label>

          <input
            type="text"
            matInput
            formControlName="assigneeId"
            placeholder="Assigned To"
            (input)="onchangemat()"
            [matAutocomplete]="myAutocomplete">

          <mat-icon matSuffix>
            <i class="icon-search"></i>
          </mat-icon>

          <mat-autocomplete #myAutocomplete="matAutocomplete" [displayWith]="getOptionText">
            <pre>{{ (conversationUsers$ | async) | json }}</pre>

            <mat-option
              *ngFor="let user of conversationUsers$ | async"
              [value]="user"
              [disabled]="user.status === 'Inactive'"
              [ngStyle]="{'color': user.status === 'Inactive' ? 'gray' : 'initial'}">

              {{ user?.label }}

            </mat-option>
          </mat-autocomplete>

        </mat-form-field>
      </ng-container>
    </div>

    <!-- Description -->
    <mat-form-field fxFlex="100" appearance="outline">
      <mat-label>Description</mat-label>
      <textarea formControlName="description" rows="3" matInput></textarea>
    </mat-form-field>

    <!-- Trigger + Due Section -->
    <ng-container *ngIf="form.get('type')?.value === 'Email'">
    <div fxLayoutAlign="start end" fxLayout="row wrap" fxLayoutGap="15px">

      <!-- Task Trigger Type -->
      <div fxFlex="1 1 30">
        <div class="due-in" fxLayout="row wrap">

          <span fxFlex="100">Task Trigger Type</span>

          <mat-form-field appearance="outline" fxFlex="100">
            <mat-select
              formControlName="taskTriggerType"
              (selectionChange)="onTaskTriggerTypeChange()">

              <mat-option
                *ngFor="let item of taskTriggerTypeOptions"
                [value]="item.value">

                {{ item.label }}

              </mat-option>

            </mat-select>
          </mat-form-field>

        </div>
      </div>

      <!-- Due In -->
      <div fxFlex="1 1 30">
        <div class="due-in" fxLayout="row wrap">

          <span fxFlex="100">
            Due in {{ form.get('taskTriggerType')?.value === 'Automatic' ? '*' : '(Optional)' }}
          </span>

          <div fxLayout="row wrap" fxLayoutGap="15px 0 grid">

            <mat-form-field appearance="outline" fxFlex="1 1 20">
              <input matInput formControlName="dueIn" type="number" placeholder="1">
            </mat-form-field>

            <mat-form-field fxFlex="1 2 45" appearance="outline">
              <mat-select formControlName="dueDateType">
                <mat-option
                  *ngFor="let item of dueDateType"
                  [value]="item.value">

                  {{ item.label }}

                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

        </div>
      </div>

      <!-- Trigger Time -->
      <div fxFlex="1 1 30" *ngIf="showTimeField">
        <div class="due-in" fxLayout="row wrap">
          <span fxFlex="100">Select Time</span>
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-select formControlName="dueDateTime">
              <mat-option
                *ngFor="let item of timeOptions"
                [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Allow Manual Execution -->
    <mat-checkbox
      *ngIf="form.get('taskTriggerType')?.value === 'Automatic'"
      formControlName="allowManualExecution"
      class="mt-10">

      Allow Manual Execution

    </mat-checkbox>
    </ng-container>

    <!-- Email Template -->
    <div fxFlex="100">
      <app-add-email-template
        *ngIf="isEmailType()"
        [preselected]="preselectedEmailTemplates"
        (chosenEmail)="addEmail($event)">
      </app-add-email-template>
    </div>

    <!-- SMS Template -->
    <div fxFlex="100">
      <app-add-sms-template
        *ngIf="isSMSType()"
        [preselected]="preselectedSmsTemplates"
        (chosenSMS)="addSMS($event)">
      </app-add-sms-template>
    </div>

    <!-- Upload Files -->
    <div *ngIf="!isEditMode">
      <app-upload-file
        [readOnly]="false"
        [fileType]="FileTypeEnum.Crm"
        [parentForm]="form">
      </app-upload-file>
    </div>

    <div *ngIf="isEditMode && files">
      <app-upload-file
        [readOnly]="false"
        [fileType]="FileTypeEnum.Crm"
        [parentForm]="form"
        [files]="files">
      </app-upload-file>
    </div>

  </form>

  <!-- Buttons -->
  <div *ngIf="Id" fxLayout="row" fxLayoutAlign="end" class="mt">
    <span class="cancel" (click)="closeDialog.emit()">Cancel</span>

    <cm-button
      color="primary"
      (click)="form.valid && record()"
      [disabled]="!form.valid">

      Save

    </cm-button>
  </div>

  <div *ngIf="!Id">

    <cm-button
      color="primary"
      class="record-btn"
      (click)="form.valid && record()"
      [disabled]="!form.valid">

      Save Task Template

    </cm-button>

  </div>

</div>